import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';

import LatestArticle from './LatestArticle';
import LatestArticleSkeleton from './LatestArticleSkeleton';
import { getLatestArticles } from '../../../../services/blog';
import 'slick-carousel/slick/slick.css';

import st from './style.module.css';

const LatestArticles = () => {
  const slider = useRef();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    getLatestArticles().then(data => {
      setArticles(data);
      setLoading(false);
    });
  }, []);

  const settings = {
    infinite: true,
    autoplay: true,
    speed: 300,
    swipe: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
  };

  return (
    <div
      className={`${st['blog-bg']} pt-[48px] md:pb-[48px] pb-[75px] flex flex-col justify-center items-center gap-[48px] md:gap-[16px] relative z-10`}
    >
      <div className="w-full max-w-[1200px] lg:bg-[rgba(255,255,255,0.75)] rounded-[10px] md:py-[33px]" style={{ backdropFilter: 'blur(4px)' }}>
        <div className="container">
          {loading ? (
            <LatestArticleSkeleton />
          ) : (
            <Slider ref={slider} {...settings} className={'z-10 w-full'}>
              {articles?.map((article, index) => (
                <LatestArticle key={index} article={article} />
              ))}
            </Slider>
          )}
        </div>
      </div>
    </div>
  );
};

export default LatestArticles;
